import styled from 'styled-components';
import { Hint } from '../Hint/Hint.js';
import { CircleTick } from '../Icons/components/CircleTick.js';
import { CircleAttention } from '../Icons/components/CircleAttention.js';

const Container = styled.div.withConfig({
    displayName: "styles__Container",
    componentId: "sc-48d408b-0"
})`
    padding: 4px 16px;
    display: flex;
    flex-direction: column;
    background-color: ${(props)=>props.theme.colors.Background};
`;
const Delimiter = styled.div.withConfig({
    displayName: "styles__Delimiter",
    componentId: "sc-48d408b-1"
})`
    background-color: ${(props)=>props.theme.colors["Level 1"]};
    height: 2px;
    margin-top: 10px;
    margin-bottom: 12px;
`;
const StyledHint = styled(Hint).withConfig({
    displayName: "styles__StyledHint",
    componentId: "sc-48d408b-2"
})`
    width: initial;
`;
const CircleTickIcon = styled(CircleTick).withConfig({
    displayName: "styles__CircleTickIcon",
    componentId: "sc-48d408b-3"
})`
    transform: scale(1.2);
`;
const CircleAttentionIcon = styled(CircleAttention).withConfig({
    displayName: "styles__CircleAttentionIcon",
    componentId: "sc-48d408b-4"
})`
    transform: scale(1.2);
`;

export { CircleAttentionIcon, CircleTickIcon, Container, Delimiter, StyledHint };
